__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/3a0f5c8/_next/";